import { render, staticRenderFns } from "./FiltersForMyBoard.vue?vue&type=template&id=0e9a7580&"
import script from "./FiltersForMyBoard.vue?vue&type=script&lang=js&"
export * from "./FiltersForMyBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e9a7580')) {
      api.createRecord('0e9a7580', component.options)
    } else {
      api.reload('0e9a7580', component.options)
    }
    module.hot.accept("./FiltersForMyBoard.vue?vue&type=template&id=0e9a7580&", function () {
      api.rerender('0e9a7580', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/kanban/components/FiltersForMyBoard.vue"
export default component.exports